import { AxiosError } from "axios";

export const parseApiError = (error: AxiosError): string | undefined => {
  const response = error.response?.data;

  // Try to parse JSON:API error response
  if (
    typeof response === "object" &&
    response !== null &&
    "errors" in response &&
    Array.isArray(response.errors) &&
    response.errors.length > 0
  ) {
    return response.errors[0].detail;
  }
};
